import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import OTPInput from "react-otp-input";
import { useState } from "react";

const OtpVerification = () => {

  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>OTP Verification</h2>
        <p>Please enter otp send to your email address</p>
        <form>
          <div className="control_group">
            <div className="opt_fields">
              <label>Enter OTP</label>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
                inputType="tel"
              />
            </div>
            <div className="auth_bottom">
              <p><span className="link" onClick={() => navigate("/")}>Resent OTP (30s)</span></p>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" onClick={() => navigate("/reset-password")}>Submit</Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p><span className="link" onClick={() => navigate("/")}><KeyboardBackspaceIcon /> Back to Login</span></p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
